import React, {useEffect, useState} from "react";
import {
    IonPage,
    IonContent, IonLoading, IonIcon, IonRefresher, IonRefresherContent
} from "@ionic/react";
import {addCircle} from "ionicons/icons";
import {
    actionToGetAssignmentDataById,
    actionToGetJobDataById,
    actionToGetOtherUsersAssignmentPostData,
    actionToGetUserAssignmentPostData,
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "./Loader/FacebookLoader";
import AssignmentDataCard from "./AssignmentDataCard";
import AssignmentsDetailSheetPopup from "./AssignmentsDetailSheetPopup";
import RaiseRFPModal from "./RaiseRFPModal";
import AssignmentMobilePage from "../pages/AssignmentMobilePage";
import {useParams} from "react-router";

export default function AssignmentMobileDashboardPage({renderHeaderPage,isMobile}) {
    const [showRaiseRFP,setShowRaiseRFP] = useState(false);
    const [isOpenMainListPanel,setIsOpenMainListPanel] = useState(false);
    const [myPostsData,setMyPostsData] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const {
        userAssignmentPostData,otherUsersAssignmentPostData,
        setIsAssignmentDetailOpen,setAssignmentDetail,isAssignmentDetailOpen,assignmentDetail
    }= useStore();
    const {id} = useParams();

    useEffect(()=>{
        if(id) {
            actionToGetAssignmentDataById(id).then((assignmentData)=>{
                if(assignmentData?.id) {
                    setAssignmentDetail(assignmentData);
                    setIsAssignmentDetailOpen(true);
                }
            });
            setTimeout(()=>{
                window.history.pushState({},null,`${window.location.origin}/dashboard/assignments`);
            },1000)
        }
    },[id])


    const handleDetailItemClick = (jobDetail)=>{
        setAssignmentDetail(jobDetail);
        setIsAssignmentDetailOpen(true);
    }

    const openMainJobListPanel = (myPosts)=>{
        setMyPostsData(myPosts);
        setIsOpenMainListPanel(true);
    }

    useEffect(() => {
        actionToGetUserAssignmentPostData();
        actionToGetOtherUsersAssignmentPostData();
    }, []);

    const handleRefresh = (event) => {
        actionToGetUserAssignmentPostData();
        actionToGetOtherUsersAssignmentPostData();
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
    };

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="looking-for-page page-content">
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent pullingText="Pull to refresh" refreshingSpinner="circles"/>
                </IonRefresher>
                <div className={"main_inner_container_common_page mobile_inner_dashboard_page job_mob_d"}>
                    {(userAssignmentPostData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    My Assigment Posts
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(userAssignmentPostData?.assignmentPostData?.length) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Assigment Posts
                                        {(userAssignmentPostData?.assignmentPostData?.length) && (
                                            <div onClick={() => setShowRaiseRFP(true)} className={"add_more"}>
                                                <IonIcon icon={addCircle}/>
                                                Add More
                                            </div>
                                        )}
                                    </div>
                                    <div onClick={()=>openMainJobListPanel(true)} className={"view_all_action_button"}>
                                        View All
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    {(userAssignmentPostData?.assignmentPostData?.map((assignment)=>(
                                        <AssignmentDataCard
                                            myPostsData={true}
                                            assignment={assignment}
                                            key={assignment.id}
                                            handleDetailItemClick={handleDetailItemClick}
                                        />
                                    )))}
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Assigment Posts
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                        <div onClick={() => setShowRaiseRFP(true)} className={"add_data_button_n_v_Data"}>
                                            <IonIcon icon={addCircle}/>
                                            Add Assignment
                                        </div>
                                        <div className={"message_no_j_d_but"}>
                                            No Assigment Posted Yet!
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }

                    {/*///////////// ALL POST DATA //////////////////*/}
                    {(otherUsersAssignmentPostData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    Other Assigment Posts
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(otherUsersAssignmentPostData?.assignmentPostData?.length) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Assigment Posts
                                    </div>
                                    <div onClick={()=>openMainJobListPanel(false)} className={"view_all_action_button"}>
                                        View All
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    {(otherUsersAssignmentPostData?.assignmentPostData?.map((assignment)=>(
                                        <AssignmentDataCard
                                            assignment={assignment}
                                            key={assignment.id}
                                            handleDetailItemClick={handleDetailItemClick}
                                        />
                                    )))}
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Assigment Posts
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                        <div className={"message_no_j_d_but"}>
                                            No Assigment Posted Yet!
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                    {/*///////////// ALL POST DATA //////////////////*/}
                </div>
            </IonContent>

            {(isAssignmentDetailOpen) ?
            <AssignmentsDetailSheetPopup
                isOpen={isAssignmentDetailOpen}
                isMobile={isMobile}
                onDidDismiss={() => setIsAssignmentDetailOpen(false)}
                assignmentDetail={assignmentDetail}/>:''
            }

            {(showRaiseRFP) ?
            <RaiseRFPModal setIsLoading={setIsLoading} isOpen={showRaiseRFP} onDismiss={() => setShowRaiseRFP(false)}/>
                :''
            }

            {(isOpenMainListPanel) ?
            <AssignmentMobilePage
                isOpen={isOpenMainListPanel}
                myPostsData={myPostsData}
                onDidDismiss={() => setIsOpenMainListPanel(false)}
            />:''
            }

            <IonLoading isOpen={isLoading} className={"loading_loader_spinner_container"} message={"Please Wait..."}/>
        </IonPage>
    )
}
